














import Vue from 'vue'
import { getCachedCategories } from '../service'

/**
 * Categories page.
 *
 * @remarks
 * Shows a list of categories.
 */
export default Vue.extend({
  name: 'Categories',
  data () {
    return {
      categories: [],
      loading: false
    }
  },
  created () {
    this.loading = true
    getCachedCategories()
      .then(
        (data) => {
          this.categories = data.amiibo
          this.loading = false
        }
      )
      .catch(
        function (err) {
          console.error('Fetch error', err)
        }
      )
  }
})
